var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component, { mixins } from "vue-class-component";
import IndexMixins from "../mixins/index";
import Swiper from "swiper";
var mIndex = /** @class */ (function (_super) {
    __extends(mIndex, _super);
    function mIndex() {
        var _this_1 = _super !== null && _super.apply(this, arguments) || this;
        _this_1.sliders = [
            // {
            //     img: require("../../static/slider/index-3.jpg")
            // },
            // {
            //     img: require("../../static/slider/index-1.jpg")
            // },
            // {
            //     img: require('../../static/slider/index-4.jpg')
            // },
            // {
            //     img: require('../../static/slider/index-2.jpg')
            // },
            {
                img: require("../../static/slider/mindex-5.jpg"),
            },
        ];
        _this_1.sliderImg = [
            {
                item: [
                    {
                        img: require("../assets/m/text.png"),
                    }
                ]
            },
        ];
        _this_1.img = [
            {
                img: require("../assets/m/01imgSchool.png"),
                title: "学校现状",
                sub: [
                    {
                        title: "“三全育人”受限",
                        content: "在学校各部门职能划分下德育的“碎化”和“割裂化”难以避免，各部门数据采集难，相互独立，无法建立以数据为中心的德育管理系统",
                    },
                    {
                        title: "管理效率低",
                        content: "数据时代下，作为培养人才的基础，校园建设化信息落后，评价系统较为落后，信息滞后，管理效率低下，相关数据无法预警",
                    },
                ],
            },
            {
                img: require("../assets/m/01student.png"),
                title: "学生现状",
                sub: [
                    {
                        title: "自我约束力弱",
                        content: "职院校学生是一个相对复杂的群体，他们大多在初中阶段学习成绩不佳，存在各种不良情绪，导致一定程度的自我约束性薄弱",
                    },
                    {
                        title: "个性鲜明",
                        content: "他们在一定程度上具有鲜明的个人特点，乐于与人交往并能更快的融入社会",
                    },
                ],
            },
        ];
        _this_1.imgtow = [
            {
                bgImg: require("../assets/m/3_bg.png"),
                arr: [require("../assets/m/3_01.png"), require("../assets/m/3_02.png")],
            },
        ];
        _this_1.imgthree = [
            {
                img: require("../../static/slider/m_Deyubg_01.jpg"),
                imgs: require("../../static/slider/Deyuimg_01.png"),
                content: [
                    {
                        img: require("../assets/other/Deyuicon01.png"),
                        title: "一站式平台",
                        cont: "一个账号通行八大应用平台，统一账户，统一数据，统一交互",
                    },
                    {
                        img: require("../assets/other/Deyuicon02.png"),
                        title: "云定制平台",
                        cont: "千校千面量身定做，学校不同，身份不同，设置不同，真正做到一校一品",
                    },
                    {
                        img: require("../assets/other/Deyuicon03.png"),
                        title: "全终端平台",
                        cont: "全终端任意平台使用，移动端，PC端，任意第三方平台",
                    },
                ],
            },
            {
                img: require("../../static/slider/m_Deyubg_02.jpg"),
                imgs: require("../../static/slider/Deyuimg_02.png"),
                content: [
                    {
                        img: require("../assets/other/Deyuicon01.png"),
                        title: "50+系统",
                        cont: "满足信息时代教、学、研、管、评需求",
                    },
                    {
                        img: require("../assets/other/Deyuicon02.png"),
                        title: "100+应用",
                        cont: "千校千面，按需定制，覆盖学校全场景应用",
                    },
                    {
                        img: require("../assets/other/Deyuicon03.png"),
                        title: "3000+报表",
                        cont: "灵活设置，促进学校个性化、精细化、智能化管理",
                    },
                ],
            },
            {
                img: require("../../static/slider/m_Deyubg_03.jpg"),
                imgs: require("../../static/slider/Deyuimg_03.png"),
                content: [
                    {
                        img: require("../assets/other/Deyuicon01.png"),
                        title: "学生成长",
                        cont: "过程性、系统性地全方面勾勒出学生的成长画像",
                    },
                    {
                        img: require("../assets/other/Deyuicon02.png"),
                        title: "学校活动",
                        cont: "实时显示校园活动统计，跟踪学生足迹，引导学生德育全面发展",
                    },
                    {
                        img: require("../assets/other/Deyuicon03.png"),
                        title: "教师发展",
                        cont: "真实记录教师的教育生涯，进一步提升教师的发展",
                    },
                ],
            },
        ];
        _this_1.schemeData = [
            {
                itemList: [
                    {
                        img: require("../assets/other/class.png"),
                        title: "班级体建设平台",
                        englishTitle: "Class collective construction platform",
                        contList: ["智能多元化评价", " 实时反馈追溯", "工作任务目标导向"],
                    },
                    {
                        img: require("../assets/other/Grownup.png"),
                        title: "学生自主成长平台",
                        englishTitle: "Student self-growth platform",
                        contList: ["考评系统", "教研系统"],
                    },
                ],
            },
            {
                itemList: [
                    {
                        img: require("../assets/other/Teacher.png"),
                        title: "班主任发展平台",
                        englishTitle: "Class teacher development platform",
                        contList: ["师生互动", "  日常任务系统", "学生成长报告单"],
                    },
                    {
                        img: require("../assets/other/Actitive.png"),
                        title: "校园文化活动平台",
                        englishTitle: "Campus cultural activity platform",
                        contList: ["活动管理", " 社团、课程管理", "活动成果分析"],
                    },
                ],
            },
            {
                itemList: [
                    {
                        img: require("../assets/other/Xinli.png"),
                        title: "心理健康平台",
                        englishTitle: "Labor education platform",
                        contList: ["职业教育阶段心理辅导"],
                    },
                    {
                        img: require("../assets/other/Laodong.png"),
                        title: "劳动教育平台",
                        englishTitle: "Class teacher development platform",
                        contList: ["智慧课堂", "学习提醒"],
                    },
                ],
            },
            {
                itemList: [
                    {
                        img: require("../assets/other/Shixi.png"),
                        title: "实习就业平台",
                        englishTitle: "Internship employment platform",
                        contList: ["岗位招聘", "  企业实习", " 就业分析"],
                    },
                    {
                        img: require("../assets/other/Liucheng.png"),
                        title: "流程管理平台",
                        englishTitle: "Process management platform",
                        contList: ["请假、宿舍流程", "多方通知(宿管、门卫)"],
                    },
                ],
            },
        ];
        _this_1.mySwiper = null;
        return _this_1;
    }
    mIndex.prototype.mounted = function () {
        var _this = this;
        this.mySwiper = new Swiper(".swiper-container", {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false, //用户操作之后是否停止自动轮播默认true
            },
            //用户操作swiper之后，是否禁止autoplay.默认为true：停止。
            autoplayDisableOnInteraction: false,
            speed: 3000,
            loop: true,
            pagination: ".swiper-pagination",
            onSlideChangeEnd: function (swiper) {
                // console.log(swiper.realIndex-2,'66'); //切换结束时，告诉我现在是第几个slide
                _this.tabIndex = swiper.realIndex + 1 == 3 ? 0 : swiper.realIndex + 1;
            },
        });
        new Swiper(".swiper-containertwo", {
            autoplay: {
                delay: 1000,
                disableOnInteraction: false, //用户操作之后是否停止自动轮播默认true
            },
            autoplayDisableOnInteraction: false,
            speed: 3000,
            loop: true,
            pagination: ".swiper-pagination-two",
        });
    };
    mIndex.prototype.slideTo = function (index) {
        this.tabIndex = index;
        this.mySwiper.slideTo(index, 1000, false);
    };
    mIndex = __decorate([
        Component
    ], mIndex);
    return mIndex;
}(mixins(IndexMixins)));
export default mIndex;
